var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"icon":"","text":"","to":("/onboarding-sched-approval/" + (item.transactionNo))}},[_c('v-icon',[_vm._v("mdi-arrow-right-bold")])],1)]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }